import { createContext } from "react";
import { CustomizableListContextProps } from "./types";

const CustomizableListContext = createContext<CustomizableListContextProps>({});

CustomizableListContext.displayName = "CustomizableListContext";

export { CustomizableListContext };
